/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const BookmarkHeaderIcon = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 19.7014C11.8806 19.7014 11.7015 19.6417 11.5821 19.5223L5.19403 12.4179C4.41791 11.5223 4 10.388 4 9.13427C4 7.88055 4.41791 6.74622 5.19403 5.8507L5.31344 5.73129C6.08956 4.83577 7.1642 4.29846 8.23882 4.29846C9.37315 4.29846 10.4478 4.77607 11.2239 5.73129L11.8209 6.38801C11.8806 6.50741 12.0597 6.50741 12.1194 6.38801L12.7164 5.73129C13.4925 4.83577 14.5672 4.29846 15.7015 4.29846C16.8358 4.29846 17.9104 4.77607 18.6866 5.73129L18.806 5.8507C19.5821 6.74622 20 7.94025 20 9.13427C20 10.388 19.5821 11.582 18.806 12.4179L12.4179 19.5223C12.2985 19.6417 12.1791 19.7014 12 19.7014Z"
          stroke="#002967"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.7386C7.89552 14.7386 7.7388 14.6863 7.63432 14.5819L2.04477 8.36545C1.36567 7.58187 1 6.58933 1 5.49232C1 4.39531 1.36567 3.40277 2.04477 2.61919L2.14926 2.51472C2.82836 1.73113 3.76867 1.26099 4.70897 1.26099C5.7015 1.26099 6.6418 1.6789 7.3209 2.51472L7.84329 3.08934C7.89553 3.19382 8.05224 3.19382 8.10448 3.08934L8.62687 2.51472C9.30597 1.73113 10.2463 1.26099 11.2388 1.26099C12.2313 1.26099 13.1716 1.6789 13.8507 2.51472L13.9552 2.61919C14.6343 3.40277 15 4.44755 15 5.49232C15 6.58933 14.6343 7.63411 13.9552 8.36545L8.36568 14.5819C8.2612 14.6863 8.15672 14.7386 8 14.7386Z"
        stroke="#002967"
        strokeWidth="1.75"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default BookmarkHeaderIcon;
